import * as React from "react";
const SvgExternalContactUpdateLeafFieldIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.5 0V8.5H16", stroke: "black" }));
export { SvgExternalContactUpdateLeafFieldIcon as ReactComponent };
